module.exports = __webpack_public_path__ + "img/AI.59fbaeec.png";